import React from "react";

import paidIcon from "images/payment/paid.svg";
import unPaidIcon from "images/payment/unpaid.svg";

export default function Header({ invoice }) {
  return (
    <div className="paymentInvoice_head">
      <div className="invoiceHead_block invoiceHead_main">
        <div className="invoiceHead_logo">
          {invoice.attributes.paid}
          <img
            alt="paid"
            src={invoice.attributes.paid ? paidIcon : unPaidIcon}
          />
        </div>
        <div className="invoiceHead_data">
          <div className="invoiceHeadData_num">
            Invoice {invoice.attributes.invoice_number}
          </div>
          <div className="invoiceHeadData_status ">
            {invoice.attributes.paid &&
              `Paid on ${invoice.attributes.paid_date}`}
            {invoice.attributes.expired &&
              `Expired on ${invoice.attributes.expired_date}`}
            {!invoice.attributes.paid && !invoice.attributes.expired && "UNPAID"}
          </div>
        </div>
      </div>
      <div className="invoiceHead_block">
        <div className="invoiceHead_date">
          <span>
            Issued on <b>{invoice.attributes.issued}</b>
          </span>
        </div>
      </div>
    </div>
  );
}

